import BaseApi from "@/core/HttpResources/BaseApi";
export default class ProposalUserReportService {
    baseApiPublish = new BaseApi("PorposalUserReport");

    async getByEvaluacionType(id: number, proposalId: number): Promise<any> {
        let baseApi = new BaseApi(`PorposalUserReport/GetGanttDiagramById/${id}/AndProposalId/${proposalId}`);
        return new Promise<any>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getMatrizAnaliticaByProposalId(id: number): Promise<any> {
        let baseApi = new BaseApi(`Porposal/GetMatrizAnaliticaByProposalId/${id}`);
        return new Promise<any>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }


    async getProposalUserReportByEvaluationId(id: number): Promise<any> {
        let baseApi = new BaseApi(`PorposalUserReportEvaluation/GetProposalUserReportByEvaluationId/${id}`);
        return new Promise<any>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async updateProposalUserReportEvaluation(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "PUT",
            "UpdateProposalUserReportEvaluation",
            model,
            {},
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
    }

    async updateAndSendProposalUserReportEvaluation(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "PUT",
            "UpdateAndSendProposalUserReportEvaluation",
            model,
            {},
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
    }


    async updateReportMatrizEvaluations(id:number, model: any): Promise<any> {
        return new Promise<any>((resolve, reject) =>
          this.baseApiPublish.request(
            "PUT",
            `UpdateEvaluations/${id}`,
            model,
            {},
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
    }

}